import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import invariant from 'tiny-invariant';
import { useAppContext } from '~/App';
import { Custom } from '~/components/job/tasks/Custom';
import { ErrorMessage } from '~/components/ui/Error';
import { JobStatus } from '~/generated/graphql';
import { ListAutomationsQuery } from '~/gql/graphql';
import { getTenantTimezone } from '~/helpers/timezoneUtils';

export const AutomationTaskView = () => {
  const navigate = useNavigate();
  const { tenant } = useAppContext();
  const { automationId, taskId } = useParams();
  const { automation } = useOutletContext<{
    automation: ListAutomationsQuery['automations'][number];
  }>();

  const handleClose = () => navigate('..');

  invariant(automationId, 'automationId missing');
  invariant(taskId, 'taskId missing');

  if (!automation || !automation.template) {
    return <ErrorMessage message='Automation or template not found' />;
  }

  const task = automation.template.tasks.find(
    (t: { id: string }) => t.id === taskId
  );

  if (!task) {
    return <ErrorMessage message='Task not found' />;
  }

  const unmaskedTask = {
    ...task,
  };

  return (
    <Custom
      job={{
        id: '0',
        status: JobStatus.Created,
        jobNumber: 'J0000',
        name: automation.jobName || automation.name,
        timeZone: getTenantTimezone(tenant),
        scheduledStartStrict: true,
        scheduledEndStrict: false,
        isSource: false,
        owner: { id: '', name: '' },
        permissions: [],
        canAcceptOffer: false,
        tasks: [],
        enforceOrder: false,
      }}
      task={{
        ...unmaskedTask,
        status: JobStatus.Created,
        // Use actual tags from the automation query
        tags: task.tags || { nodes: [] },
        // NOTE: ListAutomationsQuery doesn't include job field in tasks, so we add it here.
        // The mock job.id '0' matches the job.id above and is used by Custom component
        // to pass correct jobId to AssetView for permission checks. The Custom component
        // uses optional chaining (task?.job?.id) so this is safe even if job is missing.
        // This pattern matches the template route for consistency.
        job: { id: '0' },
      }}
      onClose={handleClose}
      onSuccess={handleClose}
      enabled={false}
    />
  );
};
